import { render } from "./OtpList.vue?vue&type=template&id=dc7833d0"
import script from "./OtpList.vue?vue&type=script&lang=js"
export * from "./OtpList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__